import * as moment from "moment";
export var dateFormat = "DD-MM-YYYY";
export var eventDateFormatFull = "DD-MM-YYYY HH:00:00";
export var monthYearFormat = "MM-YYYY";
export var dayFormat = "DD";
var CalculateDataModel = /** @class */ (function () {
    function CalculateDataModel() {
    }
    return CalculateDataModel;
}());
export { CalculateDataModel };
var ChartConfigDatasetModel = /** @class */ (function () {
    function ChartConfigDatasetModel() {
    }
    return ChartConfigDatasetModel;
}());
export { ChartConfigDatasetModel };
var ChartConfigModel = /** @class */ (function () {
    function ChartConfigModel(subset, daysBehind, year, bucketSize, cumulative) {
        if (daysBehind === void 0) { daysBehind = 30; }
        if (year === void 0) { year = null; }
        if (bucketSize === void 0) { bucketSize = 1; }
        if (cumulative === void 0) { cumulative = false; }
        this._published_at = null;
        this._threshold = 0;
        this._showThreshold = false;
        this._monthly_percentage = 0;
        this.brandPrimary = "#fe4d01";
        this.brandSuccess = "#00CD89";
        this.reset(subset, daysBehind, year, bucketSize, cumulative);
    }
    Object.defineProperty(ChartConfigModel.prototype, "published_at", {
        get: function () {
            return this._published_at;
        },
        set: function (value) {
            this._published_at = value;
            // if (!this.isYearGraph) {
            //   this.start = value;
            // }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "retreiveCorrectDateFormat", {
        get: function () {
            return this.isForEvents ? eventDateFormatFull : dateFormat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "retreiveCorrectMomentAddParam", {
        get: function () {
            // return this.isForEvents ? 'hour' : 'day';
            return this.isForEvents ? "hour" : this.isYearGraph ? "month" : "day";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "start", {
        get: function () {
            return this._start;
        },
        set: function (value) {
            this._start = value;
            this._momentStart = moment(this._start, this.retreiveCorrectDateFormat);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "momentStart", {
        get: function () {
            return this._momentStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "hasId", {
        get: function () {
            return !!this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "year", {
        get: function () {
            return this._year;
        },
        set: function (value) {
            this._year = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "hasYear", {
        get: function () {
            return !!this._year;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "isYearGraph", {
        get: function () {
            return (this._year &&
                ((this._year === moment().year() && this.daysBehind === 9999) ||
                    moment().year() > this._year));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "end", {
        get: function () {
            return this._end;
        },
        set: function (value) {
            var endDate = value;
            // if (this.year === moment().year()) {
            //   endDate = moment().format(this.retreiveCorrectDateFormat);
            // }
            this._end = endDate;
            this._momentEnd = moment(this._end, this.retreiveCorrectDateFormat);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "momentEnd", {
        get: function () {
            return this._momentEnd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        set: function (value) {
            this._ready = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "threshold", {
        get: function () {
            return this._threshold;
        },
        set: function (value) {
            this._threshold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "monthly_percentage", {
        get: function () {
            return this._monthly_percentage;
        },
        set: function (value) {
            this._monthly_percentage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "showThreshold", {
        get: function () {
            return this._showThreshold;
        },
        set: function (value) {
            this._showThreshold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "hasThreshold", {
        get: function () {
            return this.threshold > 0 && this.daysBehind === 30 && this.showThreshold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "isForEvents", {
        get: function () {
            return this.for === "events";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartConfigModel.prototype, "isForPosts", {
        get: function () {
            return this.for === "posts";
        },
        enumerable: true,
        configurable: true
    });
    ChartConfigModel.prototype.getCorrectHour = function (v) {
        return v + 2;
    };
    Object.defineProperty(ChartConfigModel.prototype, "datasetsAreEmpty", {
        /**
         * return true if no data from rest api
         */
        get: function () {
            var ret = true;
            this.datasets.forEach(function (ds) {
                if (Object.keys(ds.originalData).length > 0) {
                    ret = false;
                }
            });
            return ret;
        },
        enumerable: true,
        configurable: true
    });
    ChartConfigModel.prototype.reset = function (subset, daysBehind, year, bucketSize, cumulative) {
        var _this = this;
        if (daysBehind === void 0) { daysBehind = 30; }
        if (year === void 0) { year = null; }
        if (bucketSize === void 0) { bucketSize = 1; }
        if (cumulative === void 0) { cumulative = false; }
        this.cumulative = cumulative;
        this.sums = null;
        this.daysBehind = daysBehind;
        this.bucketSize = bucketSize;
        this._ready = false;
        this.type = "line";
        this.legend = false;
        this.subset = subset;
        this.year = year;
        this.ctr = {
            sum: 0,
            label: "CTR",
        };
        this.colors = [
            {
                // brandInfo
                backgroundColor: "transparent",
                borderColor: this.brandPrimary,
                pointHoverBackgroundColor: "#fff",
                pointBackgroundColor: this.brandPrimary,
            },
            {
                // brandSuccess
                backgroundColor: "transparent",
                borderColor: this.brandSuccess,
                pointHoverBackgroundColor: "#fff",
                pointBackgroundColor: this.brandSuccess,
            },
            {
                backgroundColor: "transparent",
                borderColor: "rgba(200, 200, 200, .7)",
                pointHoverBackgroundColor: "#fff",
            },
        ];
        this.options = {
            responsive: true,
            maintainAspectRatio: false,
            cubicInterpolationMode: "default",
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 10,
                    bottom: 0,
                },
            },
            tooltips: {
                mode: "index",
                intersect: false,
            },
            hover: {
                mode: "index",
                intersect: false,
            },
            scales: {
                xAxes: [
                    {
                        drawBorder: true,
                        gridLines: {
                            drawOnChartArea: true,
                        },
                        ticks: {
                            fontSize: 16,
                            padding: 20,
                            autoSkip: true,
                            callback: function (value, index, values) {
                                var newLabel = value;
                                if (_this.isForEvents) {
                                    var temp = moment(newLabel, eventDateFormatFull);
                                    newLabel = temp.format("DD MMM HH:mm") + "-" + temp
                                        .add(_this.retreiveCorrectMomentAddParam, _this.bucketSize)
                                        .format("HH:mm");
                                }
                                else if (_this.isYearGraph) {
                                    //  && !this.hasId
                                    newLabel = moment(value, dateFormat).format("MMM YYYY");
                                }
                                else if ((_this.bucketSize === 1 &&
                                    moment().format(dateFormat) === value) ||
                                    moment().isBetween(moment(value, dateFormat), moment(value, dateFormat).add("day", _this.bucketSize))) {
                                    newLabel = "* " + newLabel;
                                }
                                return newLabel;
                            },
                        },
                    },
                ],
                yAxes: [
                    {
                        type: "linear",
                        maxBarThickness: 100,
                        gridLines: {
                            display: false,
                            drawOnChartArea: true,
                        },
                        display: this.subset === 2 || this.subset === 0,
                        position: "right",
                        id: "y-axis-2",
                        scaleLabel: {
                            display: true,
                            labelString: this.datasets && this.datasets[1] && this.datasets[1].label
                                ? this.datasets[1].label
                                : "",
                            fontColor: this.brandSuccess,
                            fontSize: 18,
                        },
                        ticks: {
                            autoSkip: true,
                            padding: 10,
                            beginAtZero: true,
                            callback: function (value) {
                                if (Math.floor(value) === value) {
                                    return value;
                                }
                            },
                        },
                    },
                    {
                        type: "linear",
                        gridLines: {
                            display: false,
                            drawOnChartArea: true,
                        },
                        display: true,
                        position: "left",
                        id: "y-axis-1",
                        scaleLabel: {
                            display: true,
                            labelString: "",
                            fontColor: this.brandPrimary,
                            fontSize: 18,
                        },
                        ticks: {
                            autoSkip: true,
                            padding: 10,
                            beginAtZero: true,
                            callback: function (value) {
                                if (Math.floor(value) === value) {
                                    return value;
                                }
                            },
                        },
                    },
                ],
            },
            elements: {
                line: {
                    borderWidth: 2,
                },
                point: {
                    radius: 5,
                    hitRadius: 8,
                    hoverRadius: 8,
                    hoverBorderWidth: 3,
                },
            },
            legend: {
                display: false,
            },
        };
        this.labels = [];
        this.hover = function ($event) { };
        this.click = function ($event) { };
    };
    ChartConfigModel.prototype.formatAndExcludeItemsNotInRange = function (data) {
        var _this = this;
        var ret = [];
        if (this.isForEvents) {
            data.forEach(function (item) {
                var itemDate = moment(item.date, dateFormat);
                itemDate = moment(itemDate.format(dateFormat) + " " + _this.getCorrectHour(item.hour) + ":00:00", _this.retreiveCorrectDateFormat);
                if (itemDate.isBetween(_this.momentStart, _this.momentEnd, null, "[]")) {
                    ret.push({
                        date: itemDate.format(_this.retreiveCorrectDateFormat),
                        count: item.count,
                    });
                }
            });
        }
        else if (this.isYearGraph) {
            // && !this.hasId
            data.forEach(function (item) {
                var itemDate = moment("01-" + item.month + "-" + item.year, dateFormat);
                // itemDate = moment(`${itemDate.format(dateFormat)} ${this.getCorrectHour(item.hour)}:00:00`, this.retreiveCorrectDateFormat);
                // if (itemDate.isBetween(this.momentStart, this.momentEnd, null, '[]')) {
                ret.push({
                    date: itemDate.format(_this.retreiveCorrectDateFormat),
                    count: item.count,
                });
                // }
            });
            // else if (this.isForPosts && this.published_at) {
            //   const startDate: moment.Moment =
            //      this._published_at ? moment(this._published_at, this.retreiveCorrectDateFormat) : this.momentStart;
            //   data.forEach(item => {
            //     const itemDate = moment(item.date, dateFormat);
            //     // itemDate = moment(`${itemDate.format(dateFormat)} ${this.getCorrectHour(item.hour)}:00:00`, this.retreiveCorrectDateFormat);
            //     if (itemDate.isBetween(startDate, this.momentEnd, null, '[]')) {
            //       ret.push({
            //         date: itemDate.format(this.retreiveCorrectDateFormat),
            //         count: item.count
            //       })
            //     }
            //   });
            // }
        }
        else {
            ret = data;
        }
        return ret;
    };
    /**
     *
     * @param key
     * @param label
     * @param data
     * @param yAxisID
     */
    ChartConfigModel.prototype.prepareDataset = function (key, label, data, yAxisID) {
        if (yAxisID === void 0) { yAxisID = "y-axis-1"; }
        if (!this.datasets) {
            this.datasets = [];
        }
        var _ds = {
            __key: key,
            // deep cloning data from rest api
            _originalDataFromApiRest: JSON.parse(JSON.stringify(data)),
            originalData: JSON.parse(JSON.stringify(this.formatAndExcludeItemsNotInRange(data))),
            data: this.formatAndExcludeItemsNotInRange(data),
            label: label,
            yAxisID: yAxisID,
            spanGaps: true,
            lineTension: 0.4,
        };
        this.datasets.push(_ds);
        if (!this.labels || (this.labels && this.labels.length === 0)) {
            this.labels = this.calculateLabels();
        }
        this.calculateLabelsDatesArray(key);
        this.labelStringScaleLabel(label, yAxisID);
        if (!this.sums) {
            this.sums = {};
        }
        if (!this.sums[key]) {
            this.sums[key] = { sum: 0, label: "" };
        }
        this.sums[key].sum = this.sumCounters(this.datasets.find(function (dS) { return dS.__key === key; }).originalData);
        this.sums[key].label = label;
        this.calculateCtr();
        //
        this.datasets.sort(function (a, b) { return (a.__key < b.__key ? -1 : 1); });
        // specific for articvle detail
        // if published at, skipping values before this date
        // if (this.isForPosts && this.hasId && this.published_at) {
        //   this.labels = this.labels.filter(_label => moment(_label).isAfter(moment(this.published_at)));
        //   this.datasets.forEach(dataset => {
        //     dataset.data.
        //   });
        // }
        if (this.hasThreshold && !this.datasets.find(function (dS) { return dS.__key === 2; })) {
            this.calculateMontlyPercentage();
            this.datasets.push({
                __key: 2,
                _originalDataFromApiRest: new Array(this.labels.length).fill(this.threshold),
                originalData: new Array(this.labels.length).fill(this.threshold),
                data: new Array(this.labels.length).fill(this.threshold),
                label: "Monthly target",
                yAxisID: "y-axis-1",
                spanGaps: true,
                pointHoverRadius: 0,
                radius: 0,
                borderDash: [10, 5],
            });
        }
    };
    /**
     * sets the label on left and right side of the graph
     * @param label label to show
     * @param key axes id
     */
    ChartConfigModel.prototype.labelStringScaleLabel = function (label, key) {
        var optionScale = this.options.scales.yAxes.find(function (ele) { return ele.id === key; });
        if (optionScale) {
            optionScale.scaleLabel.labelString = label;
        }
    };
    /**
     * calculates counters sum given a dataset
     * @param data
     */
    ChartConfigModel.prototype.sumCounters = function (data) {
        var sum = 0;
        // return data.reduce((a, b) => a.count + b.conut, 0);
        if (Object.keys(data).length === 0) {
            return 0;
        }
        Object.keys(data).forEach(function (index) { return (sum += data[index].count); });
        return sum;
    };
    Object.defineProperty(ChartConfigModel.prototype, "labels", {
        get: function () {
            return this._labels;
        },
        set: function (labels) {
            this._labels = labels;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * method which return all "label dates" on graph "x axes"
     */
    ChartConfigModel.prototype.calculateLabels = function () {
        var allDates = [];
        var mIndexDate = this.momentStart;
        var endDate = this.momentEnd;
        if (this.year === moment().years() && this.isYearGraph) {
            endDate = moment("01-" + (moment().months() + 1) + "-" + moment().years(), this.retreiveCorrectDateFormat);
        }
        // creating all dates array based on start date, end date and bucketSize
        while (mIndexDate.isSameOrBefore(endDate)) {
            allDates.push(mIndexDate.format(this.retreiveCorrectDateFormat));
            // adding bucketSize as number of days / hours
            mIndexDate.add(this.retreiveCorrectMomentAddParam, this.bucketSize);
        }
        // if (this.isForPosts && !this.isYearGraph && this.published_at) {
        //   allDates = allDates.filter((_label) => {
        //     return moment(_label, this.retreiveCorrectDateFormat).isSameOrAfter(moment(this.published_at, this.retreiveCorrectDateFormat))
        //   });
        // }
        if (this.year !== moment().years() && this.isYearGraph) {
            allDates = allDates.slice(0, allDates.length - 1);
        }
        return allDates;
        // return allDates.slice(0, allDates.length - 1);
    };
    /**
     *
     * @param key
     */
    ChartConfigModel.prototype.calculateLabelsDatesArray = function (key) {
        var _this = this;
        // selecting correct dataset
        var currentDataset = this.datasets.find(function (ds) { return ds.__key === key; });
        //
        var pushData = function (date, count) {
            currentDataset.data.push({
                date: date.format(_this.retreiveCorrectDateFormat),
                count: count,
            });
        };
        var checkIfDateIsMissing = function (xAxesLabel) {
            // if (!this.isForEvents) {
            return !currentDataset.data.find(function (item) {
                return item.date === xAxesLabel.format(_this.retreiveCorrectDateFormat);
            });
            // } else {
            //   return !currentDataset.data.find(
            //     item => {
            //       const calcDate =
            //         moment(`${item.date} ${this.getCorrectHour(item.hour)}:00:00`, this.retreiveCorrectDateFormat);
            //       // console.log(item.date, moment(item.date, eventDateFormat).format(dateFormat));
            //       // console.log('item.date: ' + item.date, 'item.hour: ' + item.hour); // , calcDate, xAxesLabel
            //       // console.log(calcDate.isBetween(this.momentStart, this.momentEnd, 'hour', '()'), calcDate === xAxesLabel);
            //       return calcDate === xAxesLabel;
            //     }
            //   )
            // }
        };
        // looping over all "x" graph labels => array of dates,
        // if the dataset is missing a specific date, this method will fill this date with a count = 0
        this.labels.forEach(function (label) {
            var momentDate = moment(label, _this.retreiveCorrectDateFormat);
            // not event graph
            if (checkIfDateIsMissing(momentDate)
            // && (!this.isYearGraph || this.isYearGraph && this.year !== moment().year()
            // !currentDataset.data.find(
            //   item => item.date === momentDate.format(dateFormat)
            // )
            ) {
                pushData(momentDate, 0);
                // currentDataset.data.push({
                //   date: momentDate.format(dateFormat),
                //   count: 0
                // });
            }
        });
        // number array which will contains all counters data
        var counters = [];
        // sorting
        if (!this.isForEvents) {
            currentDataset.data.sort(this.compare);
        }
        else {
            currentDataset.data.sort(this.compareEvent);
        }
        // populating number array
        currentDataset.data.forEach(function (ele, index) {
            if (_this.cumulative && index) {
                ele.count += currentDataset.data[index - 1].count;
            }
            counters.push(ele.count);
        });
        // assing number array to data so can be displayed on the graph
        currentDataset.data = counters;
    };
    /**
     * !!! maybe to remove
     * @param date
     */
    ChartConfigModel.prototype._retrieveMomentDate = function (date) {
        return moment(date, dateFormat);
    };
    ChartConfigModel.prototype.getFormattedDate = function (value) {
        return moment(value).format(this.retreiveCorrectDateFormat) || null;
    };
    ChartConfigModel.prototype.compareEvent = function (a, b) {
        var _a = moment(a.date, eventDateFormatFull);
        var _b = moment(b.date, eventDateFormatFull);
        var isAfter = _a.isAfter(_b);
        if (!isAfter) {
            return -1;
        }
        if (isAfter) {
            return 1;
        }
        return 0;
    };
    ChartConfigModel.prototype.compare = function (a, b) {
        var _a = moment(a.date, dateFormat);
        var _b = moment(b.date, dateFormat);
        var isAfter = _a.isAfter(_b);
        if (!isAfter) {
            return -1;
        }
        if (isAfter) {
            return 1;
        }
        return 0;
    };
    ChartConfigModel.prototype.calculateCtr = function () {
        if (this.subset === 0) {
            if (Object.keys(this.sums).length === 2 &&
                this.sums[0].sum < this.sums[1].sum) {
                this.ctr.sum = Math.floor((this.sums[0].sum / this.sums[1].sum) * 100);
            }
        }
    };
    ChartConfigModel.prototype.calculateMontlyPercentage = function () {
        if (Object.keys(this.sums).length > 0 && this.sums[0]) {
            this.monthly_percentage = Math.floor(((this.sums[0].sum - this.threshold) * 100) / this.threshold);
        }
    };
    return ChartConfigModel;
}());
export { ChartConfigModel };
